// <script>

module.exports = {
    ready:function() {
        var that=this;
        this.show_part_index = this.$route.params.index;
    },
    data:function(){
        return {
            show_part_index: 1,
        }
    },

    methods: {
        
    }
}
// </script>
//
//
//
// <template>   
//     <div id="scroller">
//         <div class="block" v-if="show_part_index == 1">  
//             <h1>用车指导及注意事项</h1>
//             <dl>
//                 <dt>1、如何找车？</dt>
//                 <dd>
//                     选择车辆进入用车界面后，此时如果离停车场较远，可点击“导航”可直接导航至停车场；到达停车场如果车辆较多无法确认，可点击“鸣笛寻车”，车辆会打开双闪鸣笛四声，点击“开门”即可开始用车。
//                 </dd>
//
//                 <dt>2、检查车辆状态</dt>
//                 <p>
//                     2.1、检查车辆是否在充电
//                 </p>
//                 <dd>
//                     找到车后，注意先检查车辆是否处于充电状态，如果车辆正在连接充电桩充电，请先联系“响车车”客服中心400-863-7833转1，待客服远程结束充电后，将充电枪拔出放回充电桩。
//                 </dd>
//                 <p>
//                     2.2、检查车身
//                 </p>
//                 <dd>
//                     随后注意仔细观察车身或后视镜，是否出现划痕/破损，轮胎磨损/没气等情况，可通过APP取车页面“车况上报”拍照上传；车辆正常则点击“车况正常”，（如您发现伤痕但未做车况上报，系统自动默认用车前车是正常的，一旦下一个用户拍照反馈有新伤痕，我们将追责到您身上）所以在用车前，一定要仔细观察车身，拍照上传保障自己的权益。开门取车后如发现车内设备有损坏或丢失，车辆内部的任何配备设施异常或者车内有异味，可通过APP用车页面的“车况上报”进行报备，或致电客服热线 400-863-7833转1 反馈。
//                 </dd>
//                 <p>
//                     2.3、调节好座椅及后视镜
//                 </p>
//                 <dd>
//                     后视镜均为手动调节                
//                 </dd>
//
//                 <dt>3、车钥匙在哪？</dt>
//                 <dd>
//                        “响车车”所有车辆全部由APP控制，无需车钥匙，有问题请联系客服400-863-7833；
//                 </dd>
//
//                 <dt>4、如何启动车辆</dt>
//                 <dd>
//                     手机APP点击“启动”，仪表盘绿色“READY”标志亮时就可以正常使用车辆(东风景逸的车型要踩住刹车按启动)。踩下刹车，挂到D档（前进）或R档（倒车），仪表盘档位字母常亮挂挡成功，放手刹。
//                 </dd>
//
//                 <dt>5、停车注意事项</dt>
//                 <dd>
//                     需要临时停车但不还车时，请将档位挂回N档，拉手刹，关闭所有灯光，关好车窗，手机点击APP“临停”即可完成熄火操作，下车后，关上门自动上锁（请注意别把手机遗留在车上）。
//                 </dd>
//
//                 <dt>6、如何还车</dt>
//                 <dd>
//                     用车完毕后，请将档位挂回N档，拉手刹，关闭所有灯光，关好车窗，手机点击APP“还车”，车辆自动熄火。下车后，关门自动上锁，再点还车结算费用。（注意：请务必把车辆停放在网点，离开车辆后再操作还车结算，否则订单还在计费当中。）<br/>
//                     还车目前不支持跨城市还车，用户在租用车辆前，可通过app“还车网点”查看当前租用车辆去到目的地附近是否有可还车网点，再决定租用车辆，当前A点借A点还车的是广州，深圳。A点借B点还车是湛江，中山，柳州，东莞。其他城市会陆续上线，请敬请关注
//                 </dd>
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 2">  
//             <h1>车辆续航及充电</h1>
//             <dl>
//                 <dt>1、关于续航里程</dt>
//                 <dd>
//                     不同车辆的电池电量，以及续航里程不一样，选车时请参照APP上显示的电量，选择续航里程足够您出行计划来回的车辆，同时建议提前计划好寻找充电桩进行补电，使用过程中请随时电量状况，发现电量快低于30% 时，请及时充电，确保不影响您正常用车，以免因没电而产生救援费。
//                 </dd>
//
//                 <dt>2、假如车辆半路电量不足怎么办？</dt>
//                 <dd>
//                     可以寻找就近的羊城充、星星充电、特来电和爱电牛等充电桩进行充电，或将车辆还回租车网点并结算后，更换其它电量充足车辆继续使用。                
//                 </dd>
//
//                 <dt>3、每充一次电需要花多长时间？</dt>
//                 <dd>
//                     常规充电设备：需要6至8小时能完成整个充电过程。快速充电设备：空电量车大概需要1至3小时完成整个充电过程。具体根据车辆剩余续航里程以及充电桩电流输出实际情况而定。
//                 </dd>
//
//                 <dt>4、如何区分快速充电设备和常规充电设备？</dt>
//                 <dd>
//                     <!--<img style="width: 700px; height: 454px" :src="imgurl"/>-->
//                     APP上通常都将有对应标识，交流桩就是俗称的“慢充”、直流桩为俗称的”快充“，如您有疑问，请拨打客服热线400-863-7833，我们将为您服务。
//                 </dd>
//
//                 <dt>5、给车充电安全吗？</dt>
//                 <dd>
//                     响车车的车辆以及充电设施均经过安全测试，但在极端天气如：大暴雨天气，为了您的安全建议不要随便拔插充电枪，如有疑问请您在操作前致电400-863-7833。
//                 </dd>
//
//                 <dt>6、给响车车的车辆充电的操作步骤是什么？</dt>
//                 <dd>
//                     a.公共充电桩参考充电流程：<br/>
//                     （1）车辆处于熄火状态；<br/>
//                     （2）拔出充电桩上的充电枪；<br/>
//                     （3）打开车辆充电口；<br/>
//                     （4）将充电枪插入车辆充电口，并确保充电枪和车辆连接牢固；<br/>
//                     （5）用相应的APP扫码开始充电，车内有充电显示，表明已经成功开始充电；<br/>
//                 </dd>
//                 <dd>
//                     b.家用交流充电流程：注意以下条件：接地线、220V，空调插座，<br/>
//                     （1）车辆处于熄火状态；<br/>
//                     （2）找到充电开关、打开充电盖；<br/>
//                     （3）将充电枪插紧交流（慢充）充电口，打开电源，没有红色故障灯亮起，即表示充电成功；
//                 </dd>
//
//                 <dt>7、哪些地方可以充电？</dt>
//                 <dd>
//                     除响车车的网点外，还可以在国家电网、羊城充、星星充电、特来电和爱电牛等充电桩进行充电，但须您自备充电卡或下载相应的APP进行充电和费用支付。
//                 </dd>
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 3">  
//             <h1>用车规则</h1>
//             <dl>
//                 <dt>
//                    1、租用响车车车辆需具备以下条件：
//                 </dt>
//                 <dd>
//                    （1）需获得《中华人民共和国机动车驾驶证》，为了您的和他人的安全，请您遵守道路法律法规。<br/>
//                    （2）如已获得驾驶证但未满一年，属于实习期，会员在租用响车车运营车辆需自备实习标志贴，贴至后档玻璃的右上角。实习期驾龄会员在高速上行驶需有驾龄一年以上人员陪同方属于合法，如未按照规定会员私自驾驶响车车运营车辆导致被交警部门罚款、扣分以及保险公司不理赔范围由会员本人自行承担，并追究相应的法律责任，我司不作处理。<br/>
//                    （3）驾照必须有效并能够准驾自动挡车型，没有被吊销、没收、失效或以其它方式作废。如用户的驾照在任何时间被吊销、没收、失效或其状态发生变化，用户必须立即通知“响车车”，此时用户将不能使用或预定任何“响车车”车辆，否则自行承担全责。
//                 </dd>
//
//                 <dt>2、用车需保持人证合一</dt>
//                 <dd>
//                     为了保障您的个人权益驾驶证、身份证与实际驾驶人必须保持一致，防止他人在未经您许可的情况下使用您的证件。
//                 </dd>
//
//                 <dt>3、不得将会员帐号或车辆给其他人使用</dt>
//                 <dd>
//                     响车车会通过车内设备识别驾驶员身份，禁止会员将自己的会员帐号及密码交付第三人使用。若第三者凭正确的用户会员帐号及密码进行网络活动（网络预订等），或使用您的个人资料（包括但不限于手机号或会员号）进行电话预订，将被响车车视为该会员自身行为，而该行为引起的一切法律后果由会员承担。响车车会员亦不得以任何方式将车辆提供给任何非认证驾驶人驾驶。如响车车会员将汽车交予非认证驾驶人驾驶，将被永久取消会员资格，并需依法承担相应责任。
//                 </dd>
//
//                 <dt>4、车辆严禁超载</dt>
//                 <dd>
//                    响车车车辆乘坐不得超过 5 位乘客（含驾驶人）。具体按照具体车型为准，请您根据有关交通法规的标准安全载客。
//                 </dd>
//
//                 <dt>5、请不要在车内吸烟</dt>
//                 <dd>
//                     为了您和其他客户的优质体验及行车安全，请不要在车内吸烟，工作人员一旦发现租客在车内抽烟或允许他人抽烟，将被收取抽烟违约金100元。
//                 </dd>
//
//                 <dt>6、个人物品落在车内怎么办？如果在车内发现他人遗留物品怎么办？</dt>
//                 <dd>
//                     请您下车时仔细查看随身物品。 如果您发现个人物品遗落在车内，请您及时拨打客服热线 4008-637-833转1，我们会协助您进行后续跟踪找寻。 如果您在用车时发现他人物品遗留在车内，请您拍照上传至微信并拨打客服热线 4008-637-833转1，我们会为失物找到它的主人。响车车不对任何会员个人财物的损坏或丢失负责。车内承载、放置或遗留的任何个人财物均不对响车车构成任何委托责任。
//                 </dd>
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 4">  
//             <h1>事故处理</h1>
//             <dl>
//                 <dt>1、车辆在租赁过程中发生交通事故如何处理？</dt>
//                 <dd>
//                     如果在路上发生交通事故，请不要着急，如果有人员受伤，立即拨打120救援电话，拨打交通事故报警电话报警122，再拨打保险公司客服报案，同时拨打客服热线4008637833转2报备。不影响交通秩序的前提下保留第一现场，把警示牌放于事故车后150米，等待交警和保险查勘人员到达现场处理；如影响交通，请拍好第一现场照片，将车辆移开，等待交警和保险查勘人员到达现场。处理完毕后将车辆还回网点，把保险资料交给外勤工作人员处理。
//                 </dd>
//                 <dt>2、车险理赔是如何？</dt>
//                 <dd>
//                     （1）以下情况及其他保险公司不予赔偿的情况，造成的所有经济损失和后果将由您自行承担，请您务必避免：<br/>
//                     a. 超过48小时报案；<br/>
//                     b. 饮酒后驾驶车辆；<br/>
//                     c. 无证驾驶车辆；<br/>
//                     d. 持逾期未审验的驾驶执照驾驶车辆；<br/>
//                     e. 发生事故后驾车逃逸。
//                 </dd>
//                 <dd>
//                    （2）如车辆不慎出险，请您注意人身安全，并立即致电客服热线400-863-7833转2报案、收集理赔材料，齐全的理赔材料可以节省您的理赔等待时间。<br/>
//                     在您还车并提交了齐全的理赔资料时，您不需要垫付本车维修等保险公司应付费用，仅需：<br/>
//                     a)支付上表列明的保险责任内的由承租方承担的损失，以及保险责任外的所有责任和损失（如您已经购买不计免赔服务，保险责任范围外的轮胎损失您可以免于承担）；<br/>
//                     b)垫付第三方损失，该费用将在保险公司完成理赔后返还给您；(在您全责或主责的情况下，如第三方同意在响车车指定维修单位定损、维修，该费用将无需您垫付) <br/>
//                     c)在您还车不能提供齐全的理赔资料时，请根据预估的车辆损失刷取最低1500元的维修押金，该押金将在您提交完材料后的15个工作日发起退款（到账时间以各银行为准）。
//                 </dd>
//                 <dd>
//                     （3）在您用车期间，如有车辆盗抢与报废发生，您需支付公安部门立案或车管部门出具报废证明之前的车辆租赁费用。
//                 </dd>
//             </dl>
//
//             <h1>车辆故障处理</h1>
//             <dl>
//                 <dt>1、车辆在租赁过程中发生故障如何处理？</dt>
//                 <dd>
//                     如果车辆发生故障无法启动、仪表盘出现故障码、车辆爆胎、漏气等情况，先把警示牌放于车后150米，然后拨打电话客服热线4008637833转2咨询指导，等待救援。
//                 </dd>
//
//                 <dt>2、车辆在行驶过程中爆胎，保险赔偿吗？</dt>
//                 <dd>
//                     请您在行驶过程中尽量选择安全路况行驶，并在取车时或者开车前进行检查，如有车辆安全隐患方面的疑问请及时致电客服热线400-863-7833转2，；如果遇到现场爆胎，请将车辆移至安全地带，并致电客服热线400-863-7833转2我们会及时为您处理。 车辆爆胎是不属于保险赔偿范围的，如客人在租赁过程中发生非轮胎质量范围外的爆胎，我们将按照4S店的标准向您收费。
//                 </dd>
//
//                 <dt>3、停车被划伤如何处理？</dt>
//                 <dd>
//                     请您在取车时进行检查，如发现已存在车辆划伤的情况，请通过APP中的“拍照取证”或者拍照并上传至微信公众号——响车车，我们将为您进行备案。如在租赁过程中发现新的刮伤，也请您第一时间拍照上传至微信公众号——响车车，我们将根据车辆刮伤情况具体定损，如您未拍照上传，我们之后查询在您行驶中出现了新的刮伤，您有可能需要支付全款并支付车辆修理停运费用。如有疑问，请致电400-863-7833转2客服中心。
//                 </dd>
//
//                 <dt>4、车辆救援范围以及是否收费？</dt>
//                 <dd>
//                     车辆在城区范围内，我们均会为您提供救援服务。如因车辆故障问题引起的救援服务，我们将为您提供免费服务。如因您个人原因造成车辆电量耗尽而造成车辆无法行驶，我们将会根据实际情况进行有偿救援服务。
//                 </dd>
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 5">  
//             <h1>违章查询及处理</h1>
//             <dl>
//                 <dt>1、如何查询违章</dt>
//                 <dd>
//                     可在个人中心，违章信息中查看，或者“响车车”平台（以下简称平台）在收到车管所或交警大队对车辆的违章通知后，由平台客服人员通过电话或者短信的形式通知。
//                 </dd>
//
//                 <dt>2、如何进行违章处理</dt>
//                 <dd>
//                     用户可在接到电话通知起7天内自行前往车管所或交警支队处理，亦可委托平台代为处理。对于吊销驾照或单次违章扣分6分及以上的严重交通违法行为，平台有权拒绝接受委托处理。如用户接到电话通知超过7天未处理，将被视为用户自动委托“响车车”处理相关违章。“响车车”有权在违章用户账户内扣除违章罚款及代办费用。
//                 </dd>
//
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 6"> 
//             <h1>关于违章保证金</h1>
//             <dl>
//                 <dt>1、使用车辆是否收取违章保证金？</dt>
//                 <dd>
//                     响车车会员在使用租车服务时，需要会员账户缴纳达到违章保证金的最低标准即1000元人民币作为违章保证金。
//                 </dd>
//
//                 <dt>2、违章保证金如何退还？</dt>
//                 <dd>
//                     用户在确定不再用车以后，本人可用绑定注册的手机号码在APP“个人中心”内的“违章保证金余额”中进行“退违章保证金”操作，或致电“响车车”客服中心4008637833转1咨询。我们将确认用户租车期间没有违章和事故或者违章和事故已经处理完的前提下，在15个工作日（15个工作日即最后订单结算算起，不含周末跟节假日）将违章保证金退还到钱包余额，注明：余额可随时提现。
//                 </dd>
//                 <dt>3、免违章保证金说明</dt>
//                 <dd>
//                     3.1 满足芝麻信用评分550分及以上，且没有相关不良记录，可申请芝麻信用服务。<br/><br/>
//                     3.2 解除授权后将失去免违章保证金服务，需重新授权芝麻信用获得免违章保证金服务。<br/><br/>
//                     3.3 规范用车履约行为将有助于你的信用积累，恶意破坏违约将会影响信用记录。<br/><br/>
//                     3.4 当你会员等级达到黄金及以上等级时，可申请享受会员权益免违章保证金服务。<br/><br/>
//                 </dd>
//             </dl>
//         </div>
//
//         <div class="block" v-if="show_part_index == 7">  
//             <h1>用车收费</h1>
//             <dl>
//                 <dt>1、响车车项目标准费用是多少？</dt>
//                 <dd>
//                     每个地区不同车型的费用计算根据当地实际定价而定，请在选择车辆时查看相应的计费标准。
//                 </dd>
//
//                 <dt>2、响车车费用如何结算？</dt>
//                 <dd>
//                     服务结束后，响车车APP系统会根据你的消费自动结算。例：时租费用+电费=本次总租车费用
//                 </dd>
//
//                 <dt>3、如果发现我的结算费用有误怎么办？</dt>
//                 <dd>
//                     如果您对结算费用产生质疑，您可以拨打客服热线4008-637-833转3进行咨询，将有专职的客服人员为您核查并解决问题。
//                 </dd>
//
//                 <dt>4、预订成功后，如果没有取车还会收费吗？</dt>
//                 <dd>
//                     根据预定时间，我们为您免费保留15分钟取车时间，订单超过15分钟将取消订单。当天取消订单累计2次，第3次将开始自动计费。如果您没有在上述规定时间前取消预定，则取消无效，我们的系统将默认执行预定订单，相应收取车辆使用费。<br/>
//                     例如：您预订了一小时10元的服务，但您未能取车，也没有取消订单、订单超过15分钟系统将自动取消订单，若您是在取车后才取消订单，我们将收取您10元的车辆租赁费用。为了方便您和其他会员体验更好的服务，请您理解。
//                 </dd>
//
//                 <dt>5.如何享受38块包夜套餐呢？</dt>
//                 <dd>
//                     您只需要用车时长累计完结20小时后，成为白银会员及白银以上的会员，就可以享受38元包夜套餐。
//                 </dd>
//
//                 <dt>6、响车车用户付费方式？</dt>
//                 <dd>
//                     “响车车”服务采用账户余额支付，微信支付、支付宝支付，企业帐户支付等付费方式。用户在使用分时租车服务前将支付宝或微信绑定至账户，即可进行充值。
//                 </dd>
//
//                 <dt>7、如何查看我的消费和充值记录？</dt>
//                 <dd>
//                     您可以进入手机APP客户端或者微信公众号客户端登陆后，进入“个人中心”的“消费记录”查阅充值记录，查阅消费可以进入“我的订单”页面查看历史记录。
//                 </dd>
//
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 8">
//             <h1>其他可能产生的费用</h1>
//             <dl>
//                 <dt>1、预定违约费用</dt>
//                 <dd>
//                    根据预定时间，“响车车”为用户免费保留15分钟取车时间，订单超过15分钟将取消订单。当天取消订单累计2次，第3次将开始自动计费。
//                 </dd>
//
//                 <dt>2、损失费用</dt>
//                 <dd>
//                     由于用户在汽车熄火时未关闭灯光，收音机等耗电部件，以致汽车无法再次正常启动，“响车车”将为汽车实行有偿紧急救援。用户将被收取100元的蓄电池抢修费，以及蓄电池损耗费50元。
//                 </dd>
//
//                 <dt>3、维修费用</dt>
//                 <dd>
//                     用户恶意损害车内行车记录仪等车内设备，将视损坏程度按实际价值收取维修费用。
//                 </dd>
//
//                 <dt>4、驾驶违约费用</dt>
//                 <dd>
//                     如“响车车”预定用户将汽车交予非授权驾驶人驾驶，用户将被收取1000元驾驶违约费用。
//                 </dd>
//
//                 <dt>5、清洁费用</dt>
//                 <dd>
//                     将宠物带入车内或者将汽车以内部肮脏状态归还的用户应支付车辆清洁费用50-200元不等。
//                 </dd>
//
//                 <dt>6、禁烟违约费用</dt>
//                 <dd>
//                     在车内抽烟是被严格禁止的，工作人员一旦发现， 用户在车内抽烟或允许他人抽烟将被收取禁烟违约费用100元。
//                 </dd>
//
//                 <dt>7、共享车主违约费用</dt>
//                 <dd>
//                     根据共享时间，“响车车共享车主”为用户设定可租用时间段内必须在指定还车点还车，逾期归还则按照30元/小时的标准收取逾期惩罚金。
//                 </dd>
//
//                 <dt>8、车辆车身贴纸费用</dt>
//                 <dd>
//                     车辆车身的贴纸如故意性损坏需赔偿100元。
//                 </dd>
//             </dl>
//         </div>
//
//
//         <div class="block" v-if="show_part_index == 9">
//             <h1>订单取消次数过多无法下单</h1>
//             <dl>
//                 <dd>
//                     1、如果您因取消订单次数过多导致无法下单，请联系客服进行处理，同时希望您在选择车辆出行之前，确认好自己的行程，以免产生不必要的麻烦。
//                 </dd>
//
//             </dl>
//         </div>
//
//         <div class="block" v-if="show_part_index == 10">  
//             <h1>无法使用优惠券</h1>
//             <dl class="son_mb20">
//                 <p>
//                     1.请先确认您的用车订单符合优惠券的使用规则，不在优惠券使用范围内的订单，是无法使用优惠券的。
//                 </p>
//                 <p>
//                     2.优惠券是否满足了满减的条件，不达到对应满减条件则无法使用优惠券。
//                 </p>
//                 <p>
//                     3.共享用车无法使用优惠券。
//                 </p>
//                 <p>
//                     4.企业用车无法使用优惠券。
//                 </p>
//                 <p>
//                     5.套餐无法使用优惠券。
//                 </p>
//             </dl>
//         </div>
//
//         <div style="height: 1px"></div>
//     </div>
// </template>
//
//
// <style lang="sass" scoped> 
//     #scroller{
//         width: 100%;
//         padding-left: .32rem;
//         padding-right: .32rem;
//         font-size: 32px;
//         background: #fff;
//         box-sizing:border-box;
//         position:relative;
//         overflow-y:scroll;
//         -webkit-overflow-scrolling:touch;
//         .block{
//             h1 {
//                 width: 100%;
//                 height: 1.066667rem;
//                 line-height: 1.066667rem;
//                 color: #333;
//                 font-weight: bold;     
//                 font-size:.426667rem;          
//                 border-bottom:1px solid #DDDDDD;
//             }
//
//             dl {
//                 width: 100%;
//                 line-height: .64rem;
//
//                 dt {
//
//                     line-height: .64rem;
//                     font-size: .426667rem;
//                     padding: .16rem 0;
//                     font-weight: bold;
//
//                 }
//
//                 dd {
//                     line-height: .8rem;
//                     font-size: .426667rem;
//                     margin-bottom: .8rem;
//                 }
//             }
//             p{
//                 line-height: .8rem;
//                     font-size: .426667rem;
//             }
//             .son_mb20{
//                 p{
//                     margin-bottom:.266667rem;
//                 }
//             }
//         }
//     }
//
//
//
//
// </style>
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/static_page/help_detail.vue